import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
export var BoldMatchingText = function BoldMatchingText(_ref) {
  var match = _ref.match,
    children = _ref.children,
    _ref$isSmall = _ref.isSmall,
    isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall;
  if (match === '') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  // we need to escape special characters to avoid getting them interpreted in the RegExp group
  var escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
  var parts = children.split(new RegExp("(".concat(escapedSpecialCharsInMatchQuery, ")"), 'gi'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, parts.map(function (part, i) {
    if (part.toLowerCase() === match.toLowerCase()) {
      return /*#__PURE__*/React.createElement(Text, {
        testId: "cmdb-edit-dropdown-option.bold-text",
        as: "strong",
        size: isSmall ? 'small' : undefined,
        key: i
      }, part);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, part);
  }));
};
export var getVisibleAttributes = function getVisibleAttributes(attributes, attributesToDisplay) {
  var notUndefined = function notUndefined(attr) {
    return Boolean(attr);
  };
  return attributesToDisplay.map(function (attrName) {
    return attrName === 'Label' ? attributes.find(function (attr) {
      return attr.objectTypeAttribute.label;
    }) : attributes.find(function (attr) {
      return attr.objectTypeAttribute.name === attrName;
    });
  }).filter(notUndefined).filter(function (attribute) {
    return attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every(function (value) {
      return value && value.displayValue;
    });
  });
};
export var createAttributeString = function createAttributeString(attributes) {
  return attributes.map(function (attribute) {
    return attribute.objectAttributeValues.map(function (value) {
      return value.displayValue;
    }).join(', ');
  }).join(' | ');
};
export var createLabelString = function createLabelString(attributes, defaultLabel) {
  var _attributes$;
  return ((_attributes$ = attributes[0]) === null || _attributes$ === void 0 ? void 0 : _attributes$.objectAttributeValues.map(function (v) {
    return v.displayValue;
  }).join(', ')) || defaultLabel;
};